import React from 'react'

const DefaultMessage = ({ body }: { body: string }) => (
  <div className={`drift-widget-message--box drift-widget-message--STRING`}>
    {body}
  </div>
)


export default DefaultMessage
